import basicRest from '../common/CommonRestFunctions'
import axios from '../common/CommonConfigRestService'

const baseProcessUrl = '/process'

export default {
  stockOptions (filters, processId) {
    return axios.post('/process/stock-options', filters, { params: { processId: processId > 0 ? processId : undefined } }).then(response => response.data)
  },
  async downloadReport (id, number) {
    const response = await axios.get(`/process/${id}/report.xlsx`, { responseType: 'blob' })
    const url = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = url
    link.download = `parte-proceso-${number}.xlsx`
    document.body.appendChild(link)
    link.click()
    link.remove()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
  },
  getProcesses () {
    return basicRest.executeBasicAxiosGet(baseProcessUrl + '/list')
  },
  addProcess (process) {
    return basicRest.executeBasicAxiosPost(baseProcessUrl + '/save', process)
  },
  editProcess (process) {
    return basicRest.executeBasicAxiosPut(baseProcessUrl + '/edit', process)
  },
  updateStatus (id, status) {
    return basicRest.executeBasicAxiosPut(`${baseProcessUrl}/${id}/status`, { status })
  },
  getProcessById (id) {
    return basicRest.executeBasicAxiosGet(baseProcessUrl + '/' + id)
  },
  getProcessNumberList () {
    return basicRest.executeBasicAxiosGet(baseProcessUrl + '/process-number-list')
  }
}
